/*
 * Copyright 2019-2022 SURF.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

import "./Forms.scss";

import { EuiIcon, EuiPage, EuiPageSection, EuiPanel } from "@elastic/eui";
import CreateForm from "components/CreateForm";
import Explain from "components/Explain";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router";

import { get_shop_group_by_shop_id, postPutJson } from "../api/Client";
import { ShopContext } from "../utils/Shop";

export interface CreateKindPayload {
    name: string;
    c?: boolean;
    h?: boolean;
    i?: boolean;
    s?: boolean;
    description_nl?: string;
    description_en?: string;
    shop_group_id?: string;
}

export interface KindStrainPayload {
    kind_id: string;
    strain_id: string;
}

function createKind(kind: CreateKindPayload): Promise<{ id: string }> {
    return postPutJson("v1/kinds/", kind, "post", false, true);
}

async function createNewStrains(strains: string[]) {
    try {
        const promises = strains.map((strain) => {
            return postPutJson(`v1/strains/`, { name: strain }, "post", false, true);
        });
        return await Promise.all(promises);
    } catch (error) {
        console.log(error);
    }
}

export default function CreateCannabisProduct() {
    const history = useHistory();
    const [showExplanation, setShowExplanation] = useState(false);
    const { shopId } = useContext(ShopContext);

    async function handleSubmit(userInputs: any) {
        let newStrainNames = userInputs.create_new_strains;
        if (userInputs.new_strain_from_name) {
            newStrainNames.push(userInputs.kind_name);
        }
        await createNewStrains(newStrainNames);
        const shopGroup = await get_shop_group_by_shop_id(shopId);

        const kind: CreateKindPayload = {
            name: userInputs.kind_name,
            c: userInputs.kind_type === "CBD",
            h: userInputs.kind_type === "Hybrid",
            i: userInputs.kind_type === "Indica",
            s: userInputs.kind_type === "Sativa",
            description_nl: userInputs.kind_description_nl,
            description_en: userInputs.kind_description_en,
            shop_group_id: userInputs.use_shop_group ? shopGroup.id : null,
        };

        createKind(kind).then((result) => {
            console.log("Post kind succeeded");
            if (userInputs.gebruiken) {
                history.push(`/products/new-product/cannabis?selectedWiet=${result.id}`);
            } else {
                history.push("/products/cannabis");
            }
        });
    }

    return (
        <EuiPage>
            <EuiPageSection>
                <EuiPanel hasBorder={true} hasShadow={true} style={{ marginTop: "20px" }}>
                    <div className="actions">
                        <div onClick={() => setShowExplanation(true)}>
                            <EuiIcon type={"questionInCircle"} size={"xxl"} />
                        </div>
                    </div>
                    <Explain
                        close={() => setShowExplanation(false)}
                        isVisible={showExplanation}
                        title="Snel een cannabis product aanmaken"
                    >
                        <p>
                            Met dit formulier kun je snel een cannabis product aanmaken en er een prijs aan koppelen
                            zodat het cannabis product zichtbaar wordt op de prijslijst in de winkel.
                        </p>
                    </Explain>
                    <CreateForm formKey="create_kind_to_strains_form" handleSubmit={handleSubmit} />
                </EuiPanel>
            </EuiPageSection>
        </EuiPage>
    );
}
